import * as firebase from 'firebase';
import config from './config';

const firebaseConfig = {
    apiKey: config.API_KEY,
    authDomain: 'windsor-liquor.firebaseapp.com',
    databaseURL: 'https://windsor-liquor.firebaseio.com',
    projectId: 'windsor-liquor',
    storageBucket: 'windsor-liquor.appspot.com',
    messagingSenderId: '447523700665',
    appId: '1:447523700665:web:7bc74c865ded470e744068',
};
firebase.initializeApp(firebaseConfig);
const storage = firebase.storage();
const auth = firebase.auth();
const emailAuthProvider = firebase.auth.EmailAuthProvider;
const users = firebase.firestore().collection('users');
export { storage, auth, users, emailAuthProvider };
